<template>
    <div class="rcclPopover" :style="show()">
        <div class="yellowTip-m">
            <div class="yellowTip-title">{{title}}</div>
            <div class="yellowTip-txt" v-html="text"></div>
            <div class="yellowTip-btn js-popupClose" data-popupname="yellowTip" @click="confirmClick()">{{button}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RcclAlert',
    data () {
        return  {
            title: '温馨提示',
            text: '',
            button: '确定',
            isShow: false
        }
    },
    props: {
        confirmCallBack: {
            type: Function
        }
    },
    methods: {
        confirmClick () {
            this.isShow = false
            if (this.confirmCallBack) {
                this.confirmCallBack()
            }
        },
        show() {
            return this.isShow ? { 'display': 'block'} : { 'display': 'none' }
        }
    }
}
</script>

<style lang="less">
.rcclPopover .yellowTip-m {
    .yellowTip-txt {
        img {
            max-width: 100%;
            height: auto;
        }
    }
}
</style>